module.exports = __webpack_public_path__ + "0f118259ce403274f407f5e982e681c3.png";